<template>
  <div class="intangibleCate-list">
    <Row>
        <Col :xs="24" :sm="12">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                   <Button @click="showModel()" type="success" class="f-l">添加</Button>
                </FormItem> 
            </Form>
        </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
     <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
        </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus" :title="title" @on-ok="createintangibleCate('intangibleCateValidate')" :loading="loading">
        <Form :model="intangibleCate" ref="intangibleCateValidate" :rules="intangibleCateValidate" action="javascript:void(0)">
            <FormItem label="分类名称" prop="name">
                <Input v-model="intangibleCate.name" placeholder="输入分类名称..."></Input>
            </FormItem>
            <!-- <FormItem label="缩略图" prop="thumb">
                <upload-thumb v-model="intangibleCate.thumb" ref="uploadthumb" :defaultList="thumblist" tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input v-model="intangibleCate.sort" placeholder="数字越小越靠前..."></Input>
            </FormItem> -->
            <FormItem label="显示" prop="display">
                <RadioGroup v-model="bigDisplay">
                    <Radio label="是" ></Radio>
                    <Radio label="否" ></Radio>
                </RadioGroup>
            </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
export default {
    name: 'intangibleCate-list',
    data () {
        return {
            loading: true,
            dataloading: true,
            thumblist: [],
            pages:{
                page:1,
                size:10,
                total:0
            },
            title:'',
            formItem:{
                'key':'',
            },
            bigDisplay:'',
            list: [
                {
                    title: 'Id',
                    key: 'id',
                    fixed: 'left',
                    width:90
                },
                {
                    title: '名称',
                    key: 'name',
                    minWidth:200
                },
                {
                    title: '显示',
                    key: 'display',
                    minWidth:200,
                    render: (h, params) => {
                        var par = params.row.display == 1 ? '是' : '否';
                        return h('div', [
                            h('span', {
                            }, par)
                        ]);
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    width:150,
                    align: 'left',
                    fixed: 'right',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                style:{
                                    marginRight:'8px'
                                },
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.detail(params.index,params.row.id)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                style:{
                                    marginRight:'8px'
                                },
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.index,params.row.id)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            tablelist: [],
            intangibleCate:{
                name:'',
                status:true,
            },
            showModalStatus:false,
            intangibleCateValidate: {
                name: [
                    { required: true, message: '名称必须填写', trigger: 'blur' }
                ],
            },
        }
    },
    created: function () {
        // 取数据
        this.getTableList();
    },
    components: {
        UploadThumb,
    },
    methods:{
        getTableList:function(){
          this.$api.intangibleCate.list({"page":this.pages.page,"size":this.pages.size}).then(res=>{
            this.dataloading = false;
            if(res.code == 200)
            {
                this.tablelist = res.result.list;
                this.pages.total = res.result.total;
                this.$Message.success(res.msg);
            }
          });
          return;
        },
        // 展开添加
        showModel(){
            this.title="添加分类";
            this.intangibleCate={
                name:'',
            };
            this.thumblist = new Array();
            this.$refs['intangibleCateValidate'].resetFields();
            this.showModalStatus = !this.showModalStatus;
        },
        // 详情
        detail(index,id){
            this.title="编辑分类";
            this.intangibleCate={
                name:'',
            };
            this.thumblist = new Array();
            this.$refs['intangibleCateValidate'].resetFields();
            this.showModalStatus = !this.showModalStatus;
            this.$api.intangibleCate.detail({id:id}).then(res=>{
                this.intangibleCate = res.result;
                this.bigDisplay='否';
                if(this.intangibleCate.display==1){
                    this.bigDisplay='是';
                }
                // if(this.intangibleCate.thumb!=null && this.intangibleCate.thumb != ''){
                //     this.thumblist.push({
                //          name:this.intangibleCate.thumb,
                //          url:this.intangibleCate.thumb,
                //          status:'finished',
                //      });
                // }
            });
        },
        // 添加
        createintangibleCate(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.intangibleCate.display=0;
                        if(this.bigDisplay=='是'){
                            this.intangibleCate.display=1;
                        }
                    // if (this.$refs['uploadthumb'].uploadList.length>0) {
                    //     console.log(this.$refs['uploadthumb'].uploadList);
                    //     this.intangibleCate.thumb = this.$refs['uploadthumb'].uploadList[0].url;
                    // }
                    if(this.intangibleCate.id==null || this.intangibleCate.id ==0){
                        this.$api.intangibleCate.create(this.intangibleCate).then(res=>{
                            if(res.code == 200)
                            {
                                this.getTableList();
                            }
                            this.loading = false;
                            this.$nextTick(()=>{this.loading = true;});
                            this.showModalStatus = !this.showModalStatus;
                        });
                    }else{
                        this.$api.intangibleCate.edit(this.intangibleCate).then(res=>{
                            if(res.code == 200)
                            {
                                this.getTableList();
                            }
                            this.loading = false;
                            this.$nextTick(()=>{this.loading = true;});
                            this.showModalStatus = !this.showModalStatus;
                        });
                    }
                } else {
                    this.$Message.error('请检查输入的信息是否正确！');
                    this.loading = false
                    this.$nextTick(() => {this.loading = true;});
                }
            })
        },
        // 删除
        remove:function(index,id){
            // 弹出确认框
            this.$Modal.confirm({
                title: '警告',
                content: '<p>此操作不可恢复，三思而后行...</p>',
                onOk: () => {
                    this.$api.intangibleCate.remove({id:id}).then(res=>{
                        if(res.code == 200)
                        {
                            this.$Message.success(res.msg);
                            // this.tablelist.splice(index, 1);
                            this.getTableList();
                        }
                    });
                }
            });
        },
        // 修改状态
        changeStatus:function(index,value){
            this.$api.intangibleCate.status({id:index,status:value}).then(res=>{
                if(res.code == 200)
                {
                    this.$Message.success(res.msg);
                }
            });
        },
         // 翻页
        changePage() {
            this.pages.page = this.$refs['listPage'].currentPage;
            this.renderTable(1);
        },
        // 筛选
        renderTable:function(name) {
            if (name !=1){
                this.pages.page = 1;
             }
            this.dataloading = true;
            var ps = {'key':this.formItem.key,"page":this.pages.page,"size":this.pages.size};
            this.$api.intangibleCate.list(ps).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        }
    },
}
</script>
